import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { ProjectFragmentDoc } from '../../fragments/__generated__/project';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
export type UpdateProjectMutationVariables = Types.Exact<{
  code?: Types.InputMaybe<Types.Scalars['String']['input']>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  status?: Types.InputMaybe<Types.ProjectStatusEnum>;
  sector?: Types.InputMaybe<Types.Scalars['String']['input']>;
  schema_base64?: Types.InputMaybe<Types.Scalars['String']['input']>;
  background_base64?: Types.InputMaybe<Types.Scalars['String']['input']>;
  background_info?: Types.InputMaybe<Types.Scalars['String']['input']>;
  calculation_result?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'Project', id: string, code: string, status?: Types.ProjectStatusEnum | null, sector?: string | null, created_at?: number | null, updated_at?: number | null, name?: string | null, background_info?: string | null, background?: { __typename?: 'File', base64: string, path: string, filename: string, width?: number | null, height?: number | null, type: string, size: number } | null, schema?: { __typename?: 'File', filename: string, path: string } | null, preview?: { __typename?: 'File', filename: string, path: string } | null, user?: { __typename?: 'User', id: string, name?: string | null, city?: string | null, email: string, active: boolean, company?: string | null, is_admin: boolean } | null } | null };


export const UpdateProjectDocument = gql`
    mutation UpdateProject($code: String, $name: String, $status: ProjectStatusEnum, $sector: String, $schema_base64: String, $background_base64: String, $background_info: String, $calculation_result: String) {
  updateProject(
    code: $code
    name: $name
    status: $status
    sector: $sector
    schema_base64: $schema_base64
    background_base64: $background_base64
    background_info: $background_info
    calculation_result: $calculation_result
  ) {
    ...project
  }
}
    ${ProjectFragmentDoc}`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      sector: // value for 'sector'
 *      schema_base64: // value for 'schema_base64'
 *      background_base64: // value for 'background_base64'
 *      background_info: // value for 'background_info'
 *      calculation_result: // value for 'calculation_result'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;